module.exports = __webpack_public_path__ + "static/img/green-poster.02038f97.jpg";